// Angular Imports
import { Injectable } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
// Angular Material Imports
import { MatIconRegistry } from '@angular/material/icon'

/** Map of icon alias -> asset path, registered against the Material icon registry. */
const SVG_ICONS: ReadonlyArray<readonly [string, string]> = [
	['vehiculos.svg', 'assets/svgs/sidenav/vehiculos.svg'],
	['fleet-board.svg', 'assets/svgs/sidenav/fleet-board.svg'],
	['accesorios.svg', 'assets/svgs/sidenav/accesorios.svg'],
	['documentos.svg', 'assets/svgs/sidenav/documentos.svg'],
	['estados.svg', 'assets/svgs/sidenav/estados.svg'],
	['lugares.svg', 'assets/svgs/sidenav/lugares.svg'],
	['servicios-reparaciones.svg', 'assets/svgs/sidenav/servicios-reparaciones.svg'],
	['planning.svg', 'assets/svgs/sidenav/planificacion.svg'],
	['drivers.svg', 'assets/svgs/sidenav/conductores.svg'],
	['locations.svg', 'assets/svgs/sidenav/lugares.svg'],
	['square-caret-left-solid.svg', 'assets/svgs/font-awesome/square-caret-left-solid.svg'],
	['square-caret-right-solid.svg', 'assets/svgs/font-awesome/square-caret-right-solid.svg'],
	['circle-user-solid.svg', 'assets/svgs/font-awesome/circle-user-solid.svg'],
	['right-from-bracket-solid.svg', 'assets/svgs/font-awesome/right-from-bracket-solid.svg'],
	['xmark-solid.svg', 'assets/svgs/font-awesome/xmark-solid.svg'],
	['grip-vertical-solid.svg', 'assets/svgs/font-awesome/grip-vertical-solid.svg'],
	['pen-to-square-solid.svg', 'assets/svgs/font-awesome/pen-to-square-solid.svg'],
	['trash-solid.svg', 'assets/svgs/font-awesome/trash-solid.svg'],
	['history.svg', 'assets/svgs/sidenav/historial.svg'],
	['ellipsis-vertical-solid.svg', 'assets/svgs/font-awesome/ellipsis-vertical-solid.svg'],
	['eye.svg', 'assets/svgs/font-awesome/eye.svg'],
	['expand-more.svg', 'assets/svgs/font-awesome/expand-more.svg'],
	['chevron-left-solid.svg', 'assets/svgs/font-awesome/chevron-left-solid.svg'],
	['chevron-right-solid.svg', 'assets/svgs/font-awesome/chevron-right-solid.svg'],
	['rebalanceos.svg', 'assets/svgs/sidenav/rebalanceos.svg'],
	['servicios-preventivos.svg', 'assets/svgs/sidenav/servicios-preventivos.svg'],
	['siniestros.svg', 'assets/svgs/sidenav/siniestros.svg'],
	['circle-check-solid.svg', 'assets/svgs/font-awesome/circle-check-solid.svg'],
	['circle-exclamation-solid.svg', 'assets/svgs/font-awesome/circle-exclamation-solid.svg'],
	['circle-info-solid.svg', 'assets/svgs/font-awesome/circle-info-solid.svg'],
	['circle-xmark-solid.svg', 'assets/svgs/font-awesome/circle-xmark-solid.svg'],
	['multas.svg', 'assets/svgs/sidenav/multas.svg'],
	['multas-list.svg', 'assets/svgs/sidenav/multas-list.svg'],
	['reportes.svg', 'assets/svgs/sidenav/reportes.svg'],
	['configuraciones.svg', 'assets/svgs/sidenav/configuraciones.svg'],
	['diamante.svg', 'assets/svgs/sidenav/diamante.svg'],
]

@Injectable({
	providedIn: 'root',
})
export class RegisterSvgAsIconService {
	constructor(private _iconRegistry: MatIconRegistry, private _sanitizer: DomSanitizer) {
		SVG_ICONS.forEach(([name, path]) => {
			this._iconRegistry.addSvgIcon(name, this._sanitizer.bypassSecurityTrustResourceUrl(path))
		})
	}
}
